
import React from 'react'

import Announcement from '../components/Announcement'
import Slider from'../components/Slider'
import Categories from '../components/Categories'
import Products from '../components/Products'
import Newsletter from '../components/Newsletter'





const Home = () => {
    return (
        <div>
            
            <Announcement/>
            
            <Slider/>
            <Categories/>
            <Products/>
            <Newsletter/>
            

            
            
        </div>
    )
}

export default Home
